import { z } from "zod";

export const OrganizationServiceSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    organizationId: z.string().uuid(),
    createdByUserId: z.number().nullable(),
    createdAt: z.coerce.date(),
    updatedByUserId: z.number().nullable(),
    updatedAt: z.coerce.date(),
});

export type OrganizationService = z.infer<typeof OrganizationServiceSchema>;
